import { Injectable } from '@nestjs/common';
import {resourceOperationEfficiencyDTO} from './resource-operation-efficiency.dto';
import {resourceOperationEfficiency} from '../resource-operation-efficiency.entity';
import { resourceOperationEfficiencyLogDTO } from './resource-op-efficiency-log.dto';
import { ResourceOperationEfficiencyLog } from '../resource-op-efficiency-log.entity';

@Injectable()
export class ResourceOperationEfficiencyAdapter {
  
  public convertDtoToEntity(resourceOperationEfficiencyDTO: resourceOperationEfficiencyDTO,  isUpdate: boolean = false,existedOperationEfficiencyData:any ): resourceOperationEfficiency {
    const resourceoperationEfficiency = new resourceOperationEfficiency();
    resourceoperationEfficiency.resourceOperationEfficiencyId=resourceOperationEfficiencyDTO.resourceOperationEfficiencyId;
    resourceoperationEfficiency.operation=resourceOperationEfficiencyDTO.operation;
    resourceoperationEfficiency.variantCode=resourceOperationEfficiencyDTO.variantCode;
    resourceoperationEfficiency.minCount=resourceOperationEfficiencyDTO.minCount;
    resourceoperationEfficiency.maxCount=resourceOperationEfficiencyDTO.maxCount;
    resourceoperationEfficiency.efficiency=resourceOperationEfficiencyDTO.efficiency;
    // resourceoperationEfficiency.hrsPerShift=resourceOperationEfficiencyDTO.hrsPerShift;
    // company.isActive = statesDto.isActive == undefined ? true : statesDto.isActive;
    resourceoperationEfficiency.isActive=resourceOperationEfficiencyDTO.isActive==undefined?true:resourceOperationEfficiencyDTO.isActive;
    if (isUpdate) {
      let resourceOpEffLog;
        resourceoperationEfficiency.updatedUser = resourceOperationEfficiencyDTO.updatedUser;
    } else {
      resourceoperationEfficiency.isActive = true;
      resourceoperationEfficiency.createdUser = resourceOperationEfficiencyDTO.createdUser;
    }
   return resourceoperationEfficiency;
  }
  public convertEntityToDto(resourceOperationEfficiencyObject: resourceOperationEfficiency): resourceOperationEfficiencyDTO {
    const resourceOperationEfficiencyDTO= new resourceOperationEfficiency;
    resourceOperationEfficiencyDTO.resourceOperationEfficiencyId=resourceOperationEfficiencyObject.resourceOperationEfficiencyId;
    resourceOperationEfficiencyDTO.variantCode=resourceOperationEfficiencyObject.variantCode;
    resourceOperationEfficiencyDTO.minCount=resourceOperationEfficiencyObject.minCount;
    resourceOperationEfficiencyDTO.maxCount=resourceOperationEfficiencyObject.maxCount;
    resourceOperationEfficiencyDTO.isActive = resourceOperationEfficiencyObject.isActive;
    resourceOperationEfficiencyDTO.hrsPerShift=resourceOperationEfficiencyObject.hrsPerShift;
    resourceOperationEfficiencyDTO.efficiency= resourceOperationEfficiencyObject.efficiency;
    resourceOperationEfficiencyDTO.createdAt = resourceOperationEfficiencyObject.createdAt;
    resourceOperationEfficiencyDTO.updatedAt = resourceOperationEfficiencyObject.updatedAt;
    resourceOperationEfficiencyDTO.createdUser = resourceOperationEfficiencyObject.createdUser;
    resourceOperationEfficiencyDTO.updatedUser = resourceOperationEfficiencyObject.updatedUser;
    resourceOperationEfficiencyDTO.versionFlag = resourceOperationEfficiencyObject.versionFlag;
    resourceOperationEfficiencyDTO.resourceOperationEfficiencyId = resourceOperationEfficiencyObject.resourceOperationEfficiencyId;
    return resourceOperationEfficiencyDTO;
  }
}
